import React from 'react';
import {Routes, Route, Navigate} from 'react-router-dom';
import {AuthProvider} from '../features/auth';
import {Login} from '../features/auth';
import {Dashboard} from '../pages/Dashboard';
import {SettingsPage} from '../pages/Settings';
import {AudioposobiePage} from '../pages/Audioposobie';
import {PlaylistsPage, PlaylistDetailPage} from '../pages/Playlists';
import {QuizzesHubPage, QuizPlayPage} from '../pages/Quizzes';
import {ProtectedRoute, PublicRoute} from './routing';

function App() {
    return (
        <AuthProvider>
            <div className="App">
                <Routes>
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                    <Route path="/login" element={<PublicRoute> <Login /> </PublicRoute>} />
                    <Route path="/dashboard" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute> <SettingsPage /> </ProtectedRoute>} />
                    <Route path="/audioposobie" element={<ProtectedRoute> <AudioposobiePage /> </ProtectedRoute>} />
                    <Route path="/playlists" element={<ProtectedRoute> <PlaylistsPage /> </ProtectedRoute>} />
                    <Route path="/playlists/:id" element={<ProtectedRoute> <PlaylistDetailPage /> </ProtectedRoute>} />
                    <Route path="/quizzes" element={<ProtectedRoute> <QuizzesHubPage /> </ProtectedRoute>} />
                    <Route path="/quizzes/:quizId" element={<ProtectedRoute> <QuizPlayPage /> </ProtectedRoute>} />
                    <Route path="*" element={<Navigate to="/dashboard"/>}/>
                </Routes>
            </div>
        </AuthProvider>
    );
}

export default App;

